import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  templateItem: {
    paddingTop: 12,
    paddingBottom: 12,
    textAlign: 'center',
    // backgroundColor: '#f3f3f3',
    borderRadius: 12,
    cursor: 'pointer',
    border: `2px solid ${theme.palette.grey[400]}`,
    transition: 'all 0.25s linear',
    position: 'relative',
    height: 'fit-content',
    marginBottom: 6
  },
  activeTemplateItem: {
    backgroundColor: theme.palette.background.paper,
    color: theme.palette.primary.main,
    border: `2px solid ${theme.palette.primary.main}`
  },
  activeCircle: {
    position: 'absolute',
    right: 10,
    width: 12,
    height: 12,
    borderRadius: '50%',
    backgroundColor: theme.palette.primary.main
  }
}))
export default useStyles
